import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Table, IconButton, Button, Grid, Box, Tooltip, TablePagination, Input, TextField, Switch, MenuItem } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Edit, Delete } from '@material-ui/icons';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import * as RFIcon from 'react-feather';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import language from '../../languages';
import moment from "moment";

const useStyles = makeStyles({
    table: {
        width: '100%',
    },
    tableHeadRow: {
        border: '1px solid rgba(196, 196, 196, 0.1)',
        boxSizing: 'border-box',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        '& .MuiTableCell-root': {
            color: '#09205C'
        }
    },
    tableRow: {
        '& .MuiTableCell-root': {
            padding: 8,
            color: 'rgba(2, 2, 2, 0.7)',
            borderBottom: "none"
        }
    }
});


export default function BaseArrayTable(props) {
    const { rows, tableDef, formik, fieldName, lang, metaField } = props;
    const classes = useStyles();
    const [editableIndex, setEditableIndex] = useState(-1);

    useEffect(() => {
        if(rows && rows.length > 0){
            tableDef.forEach((metaRow) => {
                if(metaRow.dataType == 'timestamp') {
                    rows.forEach((row, i)=>{
                        if(row[metaRow.name] != undefined){
                            rows[i][metaRow.name] = moment.unix(row[metaRow.name]).format('YYYY-MM-DDTHH:mm');
                        }
                    })
                }
            })
        }
    }, [rows])

    const onDelete = ()=>{
        rows.splice(editableIndex, 1);
        formik.setFieldValue(fieldName, rows);
        setEditableIndex(-1)
    }
    const emptyRow = ()=>{
        let retObj = {};
        tableDef.forEach((metaRow) => {
            if(metaRow.input == 'switch') {
                retObj[metaRow.name] = metaRow.defaultValue;
            } else {
                retObj[metaRow.name] = '';
            }
        })
        return retObj;
    }
    const onAdd = ()=> {
        const row = emptyRow();
        // debugger
        rows.push(row);
        setEditableIndex(rows.length - 1)
        formik.setFieldValue(fieldName, rows);
    }
    const handleChange = (e, index)=>{
        let row = rows[index];
        if(e.target.type == 'checkbox') {
            row[e.target.name] = e.target.checked;
        } else {
            row[e.target.name] = e.target.value;
        }
        formik.setFieldValue(fieldName, rows);
    }

    return (
        <>

            <TableContainer component={Box}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow className={classes.tableHeadRow}>
                            {
                                tableDef.map((metaRow, i) => {
                                    return <TableCell key={i} >{metaRow.label}</TableCell>
                                })
                            }
                            <TableCell key={'action'}>
                                {'Action'} 
                                <IconButton color="primary" aria-label="Add" component="span"
                                        onClick={() => { onAdd() }}>
                                        <RFIcon.PlusCircle strokeWidth={1} />
                                    </IconButton>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rows && rows.length > 0) ? rows.map((row, i) => (
                            <TableRow key={i} className={classes.tableRow}>
                                {
                                    tableDef.map((metaRow, j) => {
                                        return <TableCell key={j} >
                                            { (editableIndex == i) ? 
                                                (
                                                metaRow.input == 'switch' ? 
                                                    <Switch
                                                        checked={row[metaRow.name] ? row[metaRow.name] : false}
                                                        onChange={(e)=> handleChange(e, i)} 
                                                        name={metaRow.name}
                                                        color={metaRow.color}
                                                    />
                                                : metaRow.input == 'select' ?
                                                    <TextField id={metaRow.name}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        value={row[metaRow.name]}
                                                        name={metaRow.name}
                                                        select
                                                        onChange={(e)=> handleChange(e, i)} 
                                                    >
                                                        {
                                                            metaRow.getItems().map((item, i) =>
                                                                <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                                                            )
                                                        }
                                                    </TextField>
                                                : metaRow.input == 'datetime' ?
                                                    <TextField
                                                        id={metaRow.name}
                                                        label={metaRow.label}
                                                        type="datetime-local"
                                                        size="small"
                                                        variant="outlined"
                                                        fullWidth
                                                        value={row[metaRow.name]}
                                                        name={metaRow.name}
                                                        onChange={(e)=> handleChange(e, i)} 
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        style={{width: 200+'px'}}
                                                    />
                                                :   <TextField
                                                        name={metaRow.name}
                                                        value={row[metaRow.name]}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        onChange={(e)=> handleChange(e, i)} 
                                                    /> 
                                              )
                                              :
                                                row[metaRow.name] + ''
                                                
                                            }
                                        </TableCell>
                                    })
                                }
                                <TableCell key='actions' style={{minWidth: 122}}>
                                { (editableIndex == i) ? 
                                  <>
                                    <Tooltip title={language[lang].Done} placement="bottom">
                                        <IconButton color="primary" aria-label="Done" component="span"
                                            onClick={() => setEditableIndex(-1)}>
                                            <DoneIcon style={{color: '#38A427'}} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={language[lang].Delete} placement="bottom">
                                        <IconButton color="primary" aria-label="Delete" component="span"
                                            onClick={() => onDelete()}>
                                            <CloseIcon style={{color: '#DE4646'}} />
                                        </IconButton>
                                    </Tooltip>
                                  </>
                                  :
                                    <Tooltip title={language[lang].Edit} placement="bottom">
                                        <IconButton color="primary" aria-label="Edit" component="span"
                                            onClick={() => setEditableIndex(i)}>
                                            <RFIcon.Edit2 strokeWidth={2} />
                                        </IconButton>
                                    </Tooltip>
                                }
                                </TableCell>
                            </TableRow>
                        )) : <TableRow>
                                <TableCell>
                                    {language[lang].No_Data}
                            </TableCell>
                            </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

